import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CardDetails } from '../../models/payment-charge-request.model';

@Component({
  selector: 'app-payment-card-details',
  templateUrl: './payment-card-details.component.html',
  styleUrls: ['./payment-card-details.component.scss']
})
export class PaymentCardDetailsComponent implements OnInit {
  @Input() cardDetails: CardDetails; // Replace 'any' with the actual type of cardDetails
  @Output() cardDetailsChange: EventEmitter<CardDetails> = new EventEmitter<CardDetails>();
  @Input() showAddTestCardInfo: boolean = false;
  years: any[];

  constructor() { }

  ngOnInit(): void {

    this.setupYears();
  }

  onChange() {
    this.cardDetailsChange.emit(this.cardDetails);
  }

   private setupYears(): void {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 10; i++) {
      years.push((currentYear + i).toString());
    }
    this.years = years;
  }

  addTestCardInfo() {
    this.cardDetails = {
      cardholderName: this.cardDetails.cardholderName,
      cardNumber: '4242424242424242',
      expirationMonth: '12',
      expirationYear: '2030',
      cVC: '123',
      cardholderPostalCode: '12345',
    }

    this.onChange();
  }

}
